export default __webpack_public_path__ + "static/homepage-1d002ba5718d2d38d8893a478bebf4a5.mp4";